import { Module } from '../../../ts/Module';
import { Calendar } from './Calendar';

interface IDatePickerScope extends ng.IScope {
  calendar: Calendar;
  prevMonth: () => void;
  nextMonth: () => void;
  select: (date: Date) => void;
  selectedDate: Date;

  // Callbacks
  onSelect: () => void;
}

Module.instance().directive('tbDatePicker', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'datePicker.html',
      scope: {
        selectedDate: '=',
        showToday: '@',
        onSelect: '&'
      },
      link: (scope: IDatePickerScope) => {
        scope.calendar = new Calendar(scope.selectedDate);
        scope.prevMonth = () => {
          scope.calendar.showPrevious();
        };
        scope.nextMonth = () => {
          scope.calendar.showNext();
        };
        scope.select = (date: Date) => {
          scope.selectedDate = date;
          if (scope.onSelect) {
            scope.onSelect();
          }
        };
        scope.$watch('selectedDate', (date: Date) => {
          scope.calendar.select(date);
        });
      }
    };
  }
]);
